import React from "react"
import RideBookingPassengerForm from "./RideBookingPassengerForm"

const RideBookingWrapper = () => (
  <RideBookingPassengerForm />
)

export default RideBookingWrapper
